const uploadMasterDataField = [
  'Currencies',
  'GuestCategories',
  'GuestIdentityTypes',
  'GuestTitles',
];
export default uploadMasterDataField;
